import React from "react";
import { Button, Stack } from "@mui/material";
import AltButton from "./altButton";
import { TranslatedFiles, translatedFileUrl } from "./links";

interface Props {
  // ダウンロードできる状態のときだけファイルを渡す。
  // 未指定ならボタンは押せない状態で表示される。
  files?: TranslatedFiles;
}

/**
 * 翻訳結果のダウンロードボタン群。
 * 無料版（free）と Pro 版（pro）で同じものを出すので、ここを唯一の定義とする。
 */
const DownloadButtons = (props: Props) => {
  const files = props.files;

  return (
    <Stack
      spacing={2}
      // 狭い画面では横に並べきれないので縦に積む
      direction={{ xs: "column", sm: "row" }}
      justifyContent="center"
      alignItems="center"
      sx={{ mt: 4, width: "100%" }}
    >
      {files ? (
        <Button
          variant="contained"
          sx={{ width: { xs: "100%", sm: "auto" } }}
          onClick={() => {
            window.open(translatedFileUrl(files.ja), "_blank");
          }}
        >
          下载中文 PDF 文件
        </Button>
      ) : (
        <Button
          variant="contained"
          disabled
          sx={{ width: { xs: "100%", sm: "auto" } }}
        >
          下载中文 PDF 文件
        </Button>
      )}
      <AltButton files={files} />
    </Stack>
  );
};

export default DownloadButtons;
